export { default, getServerSideProps } from '@/views/B2BSkillXP/pages/Results';
